import AppMain from "../../components/layout/AppMain";

const UserManagementRoutes = {
  path: "/users",
  component: AppMain,
  redirect: "/users/list",
  name: "UserManagement",
  meta: {
    title: "User Mananagement",
    icon: "user",
    permissions: ["view data"],
  },
  children: [
    {
      path: "list",
      component: () => import("@/views/users/ListUsers"),
      name: "ListUsers",
      meta: { title: "Users", permissions: [] },
    },
    {
      path: "edit",
      component: () => import("@/views/users/EditUser"),
      name: "Edit User",
      meta: { title: "Edit", permissions: [] },
      hidden: true,
    },
    {
      path: "invite",
      component: () => import("@/views/users/InviteUser"),
      name: "InviteUser",
      meta: { title: "Invite user", permissions: [], role: [] },
      hidden: true,
    },
    // {
    //   path: "create",
    //   component: () => import("@/views/users/Create"),
    //   name: "CreateUser",
    //   meta: { title: "Create User", permissions: [] },
    // },
    {
      path: "roles",
      component: () => import("@/views/roles/ListRoles"),
      name: "Roles and Permissions",
      meta: { title: "Roles and Permissions", permissions: [] },
    },
    {
      path: "create-role",
      component: () => import("@/views/roles/Create"),
      name: "Create Role",
      meta: { title: "Create Role", permissions: [] },
      hidden: true,
    },
    {
      path: "edit-role",
      component: () => import("@/views/roles/Edit"),
      name: "Edit Role",
      meta: { title: "Edit Role", permissions: [] },
      hidden: true,
    },
  ],
};

export default UserManagementRoutes;
